import { Schema } from 'effect';

/** The nonempty identifier sent as the backend shipment placementId. */
export const PlacementIdSchema = Schema.NonEmptyString.pipe(Schema.brand('Placement.id'));

export type PlacementId = typeof PlacementIdSchema.Type;

export const decodePlacementId = Schema.decodeUnknownSync(PlacementIdSchema);
